import { Col, Input, Row, Button, Form, message, DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import ClaimIDManuallyId from "../patient/PreAuth/ClaimIDManuallyId";
import ManualStatus from "../patient/PreAuth/ManualStatusButton";
import ManualPortalStatus from "../patient/PreAuth/ManualPortalStatusButton";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import {
  getItemsApproveByScheme,
  updateItemsApproveByScheme,
  updateSettlement,
} from "../../apis/patientService";
import dayjs from "dayjs";
import ItemsApproveBySchemeModal from "./ItemsApproveBySchemeModal";

interface SettlementProps {
  settlementData?: any[];
  fetchData: any;
}

const Settlement: React.FC<SettlementProps> = ({
  settlementData = [],
  fetchData,
}) => {
  const { patients, preAuth } = useSelector((state: RootState) => state);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);

  const handleOpenModal = async () => {
    try {
      if (!patients?.fetchBasicDetails?.visitInfoResponse?.id) return;

      const isTPAScheme =
        patients?.fetchBasicDetails?.casesResponse?.schemeType?.toUpperCase() ===
        "TPA";

      const response = await getItemsApproveByScheme(
        patients.fetchBasicDetails.visitInfoResponse.id,
        isTPAScheme
      );
      setTableData(response.data);
      setIsModalOpen(true);
    } catch (error) {
      message.error("Failed to fetch items");
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTableData([]);
  };

  const handleSaveModal = async () => {
    try {
      if (!patients?.fetchBasicDetails?.visitInfoResponse?.id) return;

      const isTPAScheme =
        patients?.fetchBasicDetails?.casesResponse?.schemeType?.toUpperCase() ===
        "TPA";

      await updateItemsApproveByScheme(
        patients.fetchBasicDetails.visitInfoResponse.id,
        isTPAScheme,
        tableData
      );
      message.success("Items updated successfully");
      handleCloseModal();
      fetchData();
    } catch (error) {
      message.error("Failed to update items");
    }
  };

  const [claimId, setClaimId] = useState("");
  const defaultSettlement = {
    intimatedAmount: "",
    approvedAmount: "",
    grossSettledAmount: "",
    settlementId: "",
    tdsAmount: "",
    taxAmount: "",
    settledDateTime: null,
  };

  // Ensure formData always has at least one object
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState<any[]>([defaultSettlement]);
  const [initialFormData, setInitialFormData] = useState<any[]>([]);

  const patientStore = useSelector((state: RootState) => state.patients);
  const { stepperData, currentStep, stageAllState } = useSelector(
    (state: RootState) => state.preAuth
  );

  const currentStageDetails = stepperData?.currentVisitStage;
  const currentActiveStage = stepperData?.visitStages[currentStep];

  const customStatus =
    currentActiveStage?.step && currentStageDetails?.step
      ? currentActiveStage.step === currentStageDetails.step
        ? currentStageDetails.stateId
        : currentActiveStage.step > currentStageDetails.step
        ? 8
        : 4
      : null;

  useEffect(() => {
    setClaimId(
      preAuth?.portalData?.casePreAuthCghs?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
          ?.claimId ||
        preAuth?.portalData?.casePreAuthIhx?.claimId ||
        preAuth?.portalData?.casePreAuthStarhealth?.claimId
    );
  }, [preAuth?.portalData]);

  useEffect(() => {
    if (settlementData.length > 0) {
      setFormData(settlementData);
      setInitialFormData(settlementData);
    }
  }, [settlementData]);
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
    index: number
  ) => {
    const { value } = e.target;
    if (key === "settlementId" || /^\d*\.?\d*$/.test(value) || value === "") {
      const updatedFormData = [...formData];
      updatedFormData[index] = {
        ...updatedFormData[index],
        [key]: value,
      };
      setFormData(updatedFormData);
    }
  };

  const handleInputDateChange = (value: any, key: string, index: number) => {
    const updatedFormData = [...formData];
    updatedFormData[index] = {
      ...updatedFormData[index],
      [key]: value ? dayjs(value).format("DD-MM-YYYY HH:mm:ss") : null,
    };
    setFormData(updatedFormData);
  };

  const handleSave = async () => {
    // Validation: Check if any settlement entry has an empty Settlement ID
    // const hasEmptySettlementId = formData.some(
    //   (data) => !data.settlementId?.trim()
    // );

    // if (hasEmptySettlementId) {
    //   message.error("Error: Settlement ID is required!");
    //   return; // Stop function execution if validation fails
    // }
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        const updatedFormData = formData?.map((data) => ({
          ...data,
          settledDateTime: data.settledDateTime
            ? dayjs(data.settledDateTime, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          settlementRegisterId: data.settlementRegisterId || null,
          claimId: claimId || null, // Ensure claimId exists
        }));
        await updateSettlement(
          updatedFormData,
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        );

        message.success("Settlement Updated");
        setIsEditing(false);
        fetchData();
      } catch (error: any) {
        message.error(error);
        setFormData(initialFormData);
      }
    }
  };

  return (
    <div
    // style={{
    //   border: "0.4px solid rgb(87, 87, 87)",
    //   borderRadius: "16px",
    //   margin: "0px 0.5rem",
    // }}
    >
      <div
        style={{
          // minHeight: "64px",
          // background: "rgb(243, 243, 243)",
          // padding: "12px 35px",
          // borderRadius: "16px 16px 0px 0px",
          // borderBottom: "1px solid rgb(166, 166, 166)",
          // fontWeight: "600",
          // fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            textDecoration: "underline",
            fontSize: "16px",
            margin: "16px 0",
            fontWeight: "bold",
          }}
        >
          Settlement
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "10px",
          }}
        >
          {/* <Button
            style={{
              color: "white",
              background: "#004c8f",
              border: "1px solid #004c8f",
              boxShadow: "0px 2px 8px 0px #00000040",
              borderRadius: "10px",
              padding: "12px 25px",
              marginRight: "0.8rem",
            }}
            onClick={handleOpenModal}
          >
            Items Approved By Scheme
          </Button> */}
          <Button
            style={{
              color: "white",
              background: "#004c8f",
              border: "1px solid #004c8f",
              boxShadow: "0px 2px 8px 0px #00000040",
              borderRadius: "10px",
              padding: "12px 25px",
              marginRight: "0.8rem",
            }}
            onClick={() => setIsEditing(!isEditing)}
          >
            {isEditing ? "Cancel" : "Edit"}
          </Button>
          {isEditing && (
            <Button
              style={{
                color: "#004c8f",
                background: "white",
                border: "1px solid #004c8f",
                boxShadow: "0px 2px 8px 0px #00000040",
                borderRadius: "10px",
                padding: "12px 25px",
                marginRight: "0.8rem",
              }}
              type="primary"
              onClick={handleSave}
            >
              Save
            </Button>
          )}
        </div>
        {/* <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <ClaimIDManuallyId />
          {currentActiveStage?.visitStageId &&
            patientStore?.fetchBasicDetails?.visitInfoResponse?.id && (
              <ManualStatus
                stateData={
                  stageAllState?.[currentActiveStage?.visitStageId] || null
                }
                status={customStatus}
                visitId={patientStore?.fetchBasicDetails?.visitInfoResponse?.id}
                visitStageId={currentActiveStage?.visitStageId}
                isUpdateable={true}
              />
            )}
          {patientStore?.fetchBasicDetails?.visitInfoResponse?.portalStatus && (
            <ManualPortalStatus
              status={
                patientStore?.fetchBasicDetails?.visitInfoResponse
                  ?.portalStatus || "-"
              }
              visitId={patientStore?.fetchBasicDetails?.visitInfoResponse?.id}
              visitStageId={currentActiveStage?.visitStageId}
              isUpdateable={false}
            />
          )}
        </div> */}
      </div>

      {/* //className="settlement-content" style={{ padding: "20px" }} */}
      <div>
        <div
          style={{
            // boxShadow: "0px -1px 3px 0px #00000040 inset",
            marginBottom: "1rem",
          }}
        >
          <Form layout="vertical" style={{ padding: "30px" }}>
            {formData.map((data, index) => (
              <Row gutter={16} key={index}>
                <Col span={8}>
                  <Form.Item label={`Intimated Amount`}>
                    <Input
                      prefix="₹"
                      value={data.intimatedAmount}
                      onChange={(e) =>
                        handleInputChange(e, "intimatedAmount", index)
                      }
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={`Approved Amount`}>
                    <Input
                      prefix="₹"
                      value={data.approvedAmount}
                      onChange={(e) =>
                        handleInputChange(e, "approvedAmount", index)
                      }
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={`Gross Settled Amount`}>
                    <Input
                      prefix="₹"
                      value={data.grossSettledAmount}
                      onChange={(e) =>
                        handleInputChange(e, "grossSettledAmount", index)
                      }
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={<span>Settlement ID</span>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please enter Settlement Id",
                    //   },
                    // ]}
                  >
                    <Input
                      prefix="#"
                      value={data.settlementId}
                      onChange={(e) =>
                        handleInputChange(e, "settlementId", index)
                      }
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={`TDS`}>
                    <Input
                      prefix="₹"
                      value={data.tdsAmount}
                      onChange={(e) => handleInputChange(e, "tdsAmount", index)}
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={`TAX`}>
                    <Input
                      prefix="₹"
                      value={data.taxAmount}
                      onChange={(e) => handleInputChange(e, "taxAmount", index)}
                      style={{ color: "black" }}
                      disabled={!isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={`Settled Date`}>
                    <DatePicker
                      showTime
                      value={
                        data.settledDateTime &&
                        dayjs(
                          data.settledDateTime,
                          "DD-MM-YYYY HH:mm:ss",
                          true
                        ).isValid()
                          ? dayjs(data.settledDateTime, "DD-MM-YYYY HH:mm:ss")
                          : null
                      }
                      format={"DD-MM-YYYY HH:mm:ss"}
                      onChange={(e) =>
                        handleInputDateChange(e, "settledDateTime", index)
                      }
                      disabled={!isEditing}
                      style={{ color: "black", width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </Form>
        </div>
      </div>

      <ItemsApproveBySchemeModal
        isModalOpen={isModalOpen}
        handleCancel={handleCloseModal}
        handleSave={handleSaveModal}
        tableData={tableData}
        setTableData={setTableData}
      />
    </div>
  );
};

export default Settlement;
